import { Wine, ChefHat, Flame, MapPin } from "lucide-react";

const Hero = () => {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const trustBadges = [
    { icon: ChefHat, label: "Tapas gourmet" },
    { icon: Wine, label: "Gran selección de vinos" },
    { icon: Flame, label: "Carnes a la brasa" },
    { icon: MapPin, label: "Mercado de Abastos" },
  ];

  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center justify-center"
    >
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1602755088318-39b7a7e6482a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxnb3VybWV0JTIwdGFwYXMlMjBzcHJlYWQlMjBzcGFuaXNoJTIwZm9vZHxlbnwwfHx8fDE3NzMzNDc0MzZ8MA&ixlib=rb-4.1.0&q=85"
          alt="Tapas gourmet en Sevilla Este - Abacería Como en Casa"
          className="w-full h-full object-cover"
        />
        <div className="hero-overlay absolute inset-0" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center text-white px-6 max-w-5xl mx-auto">
        {/* Decorative element */}
        <div className="elegant-divider mb-8 opacity-0 animate-fade-in animation-delay-100">
          <Wine className="text-[#C5A059]" size={28} />
        </div>

        {/* Main Title - H1 SEO optimizado */}
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-7xl mb-6 opacity-0 animate-fade-in-up animation-delay-200">
          Abacería Como en Casa – Tapas y vinos en Sevilla Este
        </h1>

        {/* Subtitle */}
        <p className="font-accent text-xl sm:text-2xl lg:text-3xl text-[#C5A059] mb-6 opacity-0 animate-fade-in-up animation-delay-300">
          Tapas gourmet y ambiente andaluz en el Mercado de Abastos
        </p>

        {/* Description */}
        <p className="font-body text-base sm:text-lg text-white/90 max-w-3xl mx-auto mb-10 leading-relaxed opacity-0 animate-fade-in-up animation-delay-400">
          Disfruta de ibéricos de bellota, carnes a la brasa, mariscos frescos y una bodega
          única en el Mercado de Abastos de Sevilla Este.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16 opacity-0 animate-fade-in-up animation-delay-500">
          <a
            href="#reservas"
            onClick={(e) => scrollToSection(e, "#reservas")}
            data-testid="hero-reserve-btn"
            className="btn-primary inline-block"
          >
            Reservar Mesa
          </a>
          <a
            href="#carta"
            onClick={(e) => scrollToSection(e, "#carta")}
            data-testid="hero-menu-btn"
            className="px-8 py-4 border border-white text-white uppercase tracking-widest text-xs hover:bg-white hover:text-[#1A1A1A] transition-all duration-300 inline-block"
          >
            Ver Carta
          </a>
        </div>

        {/* Trust Badges */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 opacity-0 animate-fade-in animation-delay-500">
          {trustBadges.map((badge, index) => (
            <div
              key={index}
              className="flex flex-col items-center gap-2 text-white/80"
            >
              <badge.icon size={24} className="text-[#C5A059]" />
              <span className="font-body text-xs uppercase tracking-wider">
                {badge.label}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center pt-2">
          <div className="w-1 h-2 bg-white/50 rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
